import { render } from "./NotificationForm.vue?vue&type=template&id=39c7a8e0&ts=true"
import script from "./NotificationForm.vue?vue&type=script&lang=ts"
export * from "./NotificationForm.vue?vue&type=script&lang=ts"

import "./NotificationForm.vue?vue&type=style&index=0&id=39c7a8e0&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__